import axios from 'axios';
import lib from '@/lib';

export default class AuthModel
{
	/**
	 * Конструктор
	 */
	constructor()
	{
		// Инициализация
		this.authChecked = false;
		this.token = lib.localStorageGet('token')||'';
		
		this.userProfile = null;
		
		if (this.token) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
		}
		axios.defaults.headers.common['Content-Type'] = 'application/json';
	}
	
	/**
	 * Инициализация данных пользователя
	 */
	async doInitData()
	{
		if (!this.authChecked && this.token) {
			try {
				const response = await axios.get('/api/user/get-init-data', {
					params: {
						lang: storeInstance.state.app.getLang(),
					},
					mode: 'cors',
					cache: 'no-cache',
					withCredentials: true,
				});
				this.setUserProfile(response.data.user_data);
				this.authChecked = true;
			} catch (error) {
				console.error(error);
				if (error.response) {
					return {
						success: false,
						...error.response.data,
					};
				} else {
					return {
						success: false,
						error: error.message,
					};
				}
			}
		}
		return {
			success: true,
		};
	}
	
	/**
	 * Авторизация администратора
	 */
	async doLoginAdmin(password)
	{
		try {
			const response = await axios.post('/api/auth/admin/login', {
				password,
			}, {
				params: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			const data = response.data;
			if (data.error && data.error !== '') {
				console.error(data.error || '');
				this.userProfile = null;
				lib.localStorageRemove('token');
				this.token = '';
				delete axios.defaults.headers.common['Authorization'];
				this.authChecked = false;
				return {
					success: false,
					code: data.code,
					error: data.error,
				};
			}
			const token = data.token;
			lib.localStorageSet('token', token, 0);
			this.token = token;
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			this.setUserProfile(data.user_data);
			this.authChecked = true;
			return {
				success: true,
			};
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			lib.localStorageRemove('token');
			this.token = '';
			delete axios.defaults.headers.common['Authorization'];
			this.authChecked = false;
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	async doLoginEditor(password)
	{
		try {
			const response = await axios.post('/api/auth/editor/login', {
				password,
			}, {
				params: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			const data = response.data;
			if (data.error && data.error !== '') {
				console.error(data.error || '');
				this.userProfile = null;
				lib.localStorageRemove('token');
				this.token = '';
				delete axios.defaults.headers.common['Authorization'];
				this.authChecked = false;
				return {
					success: false,
					code: data.code,
					error: data.error,
				};
			}
			const token = data.token;
			lib.localStorageSet('token', token, 0);
			this.token = token;
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			this.setUserProfile(data.user_data);
			this.authChecked = true;
			return {
				success: true,
			};
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			lib.localStorageRemove('token');
			this.token = '';
			delete axios.defaults.headers.common['Authorization'];
			this.authChecked = false;
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	async doLoginExam(password)
	{
		try {
			const response = await axios.post('/api/auth/exam/login', {
				password,
			}, {
				params: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			const data = response.data;
			if (data.error && data.error !== '') {
				console.error(data.error || '');
				this.userProfile = null;
				lib.localStorageRemove('token');
				this.token = '';
				delete axios.defaults.headers.common['Authorization'];
				this.authChecked = false;
				return {
					success: false,
					code: data.code,
					error: data.error,
				};
			}
			const token = data.token;
			lib.localStorageSet('token', token, 0);
			this.token = token;
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			this.setUserProfile(data.user_data);
			this.authChecked = true;
			return {
				success: true,
			};
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			lib.localStorageRemove('token');
			this.token = '';
			delete axios.defaults.headers.common['Authorization'];
			this.authChecked = false;
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Деавторизация
	 */
	async doLogout()
	{
		if(storeInstance.state.app.isExamStarted()){
			storeInstance.state.app.doFinishExam(storeInstance.state.app.sel_exam_id, storeInstance.state.app.sel_student_id);
		}
		storeInstance.state.app.sel_exam_id = '';
		lib.localStorageRemove('sel_exam_id');
		storeInstance.state.app.sel_student_id = '';
		lib.localStorageRemove('sel_student_id');
		
		this.userProfile = null;
		lib.localStorageRemove('token');
		this.token = '';
		delete axios.defaults.headers.common['Authorization'];
		this.authChecked = false;
		
		return true;
	}
	
	isAuth()
	{
		return this.token != '' && this.userProfile != null;
	}
	
	isAdmin()
	{
		return this.getUserId() === 1;
	}
	
	isEditor()
	{
		return this.getUserId() === 2;
	}
	
	isStudent()
	{
		return this.getUserId() === 3;
	}
	
	getUserId()
	{
		return this.userProfile != null ? this.userProfile.user_id : '';
	}
	
	/**
	 * Устанавливает user profile
	 */
	setUserProfile(res)
	{
		if(res == null){
			this.userProfile = null;
		} else {
			this.userProfile = {
				user_id: res.id,
			};
		}
	}
}
